/* Style only the Shopify Forms side tab */
(function () {
  var CSS = `
    #app-embed[data-current-step="tease"] {
      left: 0 !important;
      top: 50% !important;
      right: unset !important;
      padding: 0 !important;
      transform-origin: 0 0 !important;
      rotate: none !important;
      transform: rotate(-90deg) translateX(-50%) !important;
    }
    [data-testid="form-teaser"] {
      padding: 6px 14px !important;
      border-radius: 0 0 10px 10px !important;
      min-height: 0 !important;
      animation: voightTabIn .45s ease-out both;
    }
    [class*="_teaserHeading_"] {
      font-family: var(--bodyFontFamily, inherit) !important;
      font-size: 11px !important;
      letter-spacing: .1em !important;
      line-height: 1 !important;
      margin: 0 !important;
    }
    @keyframes voightTabIn {
      from { transform: translateY(-100%); opacity: 0; }
      to   { transform: none; opacity: 1; }
    }
  `;

  function apply() {
    var done = true;
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root) { done = false; return; }
      if (!root.querySelector('style[data-voight]')) {
        var s = document.createElement('style');
        s.setAttribute('data-voight', '');
        s.textContent = CSS;
        root.appendChild(s);
      }
    });
    return done && document.querySelector('shopify-forms-embed');
  }

  var tries = 0;
  var timer = setInterval(function () {
    if (apply() || ++tries > 40) clearInterval(timer);
  }, 500);
})();